import React, { FC } from 'react';

import { useRestrictedModal } from '../../../../../../components/modal/useRestrictedModal';
import { useUser } from '../../../../../../user/useUser';

import { getFormattedDate } from '../../../../../../utils/date-utils/dateUtils';

import { LegislationInfos } from '../../../../legislation.types';

import styles from './versions_selector.module.scss';

type Props = {
  articleId: string;
  compareVersions: Function;
  legislationInfosAll: Array<LegislationInfos>;
};

export const VersionsSelector: FC<Props> = ({
  articleId,
  compareVersions,
  legislationInfosAll,
}) => {
  const { accessPremium } = useUser();
  const { openRestrictedModal } = useRestrictedModal();
  const tryToChangeVersion = (event: React.MouseEvent<HTMLSelectElement>) => {
    if (!accessPremium) {
      event.preventDefault();
      openRestrictedModal({ source: 'versions_law' });
    }
  };

  if (!legislationInfosAll) return null;

  return (
    <select
      className={styles.select}
      onChange={(event: React.ChangeEvent<HTMLSelectElement>) =>
        event.target && compareVersions(event.target.value)
      }
      onMouseDown={tryToChangeVersion}
      value={articleId}
    >
      {legislationInfosAll.map((version) => (
        <option value={version.articleId} key={version.articleId}>
          {!window.mobile && 'Version du '}
          {getFormattedDate(version.startingDate)}
          {version.endingDate && ` au ${getFormattedDate(version.endingDate)}`}
        </option>
      ))}
    </select>
  );
};
